<p-dialog [visible]="true" [breakpoints]="{'440px': '100%'}" [style]="{width: '90%'}" [baseZIndex]="10000"
  [ngClass]="{'change-scrollbar-color-darkMode': settings.darkModeSetting, 'change-scrollbar-color': !settings.darkModeSetting}"
  [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false">
  <dialog-header [title]="action.name" [settings]="settings" [icon]="faPen"></dialog-header>
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 relative">
      <ng-template [ngIf]="!action.hasEditProc">
        <button class="btn font17" (click)="addRow()">
          <fa-icon [icon]="faPlus" class="textGreen"></fa-icon>
          <span class="btnControlText" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
            {{app.translations.GRID_btn_Add}}
          </span>
        </button>
        <button class="btn font17" (click)="pasteExcelData()">
          <fa-icon [icon]="faPaste" class="textGreen"></fa-icon>
          <span class="btnControlText" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
            {{app.translations.GBL_btn_PasteData}}
          </span>
        </button>
      </ng-template>
      <ng-template [ngIf]="selectedLines.length > 0">
        <span class="font15 float-right" style="margin: 9px 0px 0px;"
          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
          {{app.translations.GRID_lbl_EditLineCount}} : <strong>{{gridRows.length}}</strong>
        </span>
      </ng-template>
    </div>
  </div>
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'" style="padding: 10px 0px !important;">
    <div class="col-12">
      <ng-template [ngIf]="gridRows.length == 0 && selectedLines.length > 0">
        <div class="text-center">
          <span class="font30" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlue'">
            <fa-icon [icon]="faCircleNotch" class="textGreen"></fa-icon>
          </span>
        </div>
      </ng-template>
      <ng-template [ngIf]="gridRows.length > 0">
        <table class="full-width">
          <thead>
            <tr>
              <th class="padding5" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'"></th>
              <ng-container *ngFor="let param of parameters">
                <th class="padding5" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                  <span class="font14"
                    [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{param.caption}}</span>
                  <ng-template [ngIf]="param.mandatory == 'Y'">
                    <span class="font12 italic" style="transform: translateX(10px);"
                      [ngClass]="settings.darkModeSetting ? 'textGreyb9' : 'textBlack'">
                      {{app.translations.GBL_lbl_Required}}</span>
                  </ng-template>
                </th>
              </ng-container>
              <ng-template [ngIf]="isSavingGrid">
                <th class="animated fadeIn padding5" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'"></th>
              </ng-template>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of gridRows">
              <tr class="animated fadeIn">
                <td class="padding5" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                  <fa-icon [icon]="faTrash" class="font17 cursorPointer padding5 b-radius" (click)="removeRow(item)"
                    [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textGreen'"></fa-icon>
                </td>
                <ng-container *ngFor="let param of item.params">
                  <td class="padding5" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                    <ng-template [ngIf]="param.type == 'multiselect'">
                      <div class="animated fadeIn col-12" (click)="opMulti.toggle($event)">
                        <div class="form-control relative" style="height: fit-content; min-height: 34px;">
                          <div #optionEl *ngFor="let item of param.multiValueArray">
                            <span class="b-radius textWhite multi-select-item"
                              [ngClass]="'font' + settings.textSizeSetting">
                              {{item}}
                              <fa-icon [icon]="faXmark" class="bg-none combo-input-icon cursorPointer textWhite"
                                (click)="unselectOption(item, param)"
                                [ngClass]="'font' + settings.textSizeSetting"></fa-icon>
                            </span>
                          </div>
                          <fa-icon [icon]="faListCheck" class="absolute bg-none combo-input-icon cursorPointer padding5"
                            (click)="opMulti.toggle($event);"
                            [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"></fa-icon>
                        </div>
                        <p-overlayPanel #opMulti styleClass="overlay-b">
                          <ng-template pTemplate="content" class="full-width unset-p">
                            <div class="combo-options-container b-radius p-unset overflow-auto full-width"
                              [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                              <div #optionEl *ngFor="let item of param.lookupValues; let i = index"
                                class="combo-option poppins relative"
                                [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                                <mat-checkbox [checked]="param.value.includes(item.value)"
                                  style="transform: translate(3px, 5px);"
                                  (change)="updateMultiSelectCombos($event, param, item.value)">
                                </mat-checkbox>
                                <span class="absolute" style="top: 50%; transform: translate(10px, -50%);">
                                  {{ item.value }}
                                </span>
                              </div>
                              <span *ngIf="param.lookupValues && param.lookupValues.length === 0"
                                class="combo-option poppins flex justify-centre align-centre"
                                [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                                {{app.translations.GBL_lbl_NoResults}}
                              </span>
                            </div>
                          </ng-template>
                        </p-overlayPanel>
                      </div>
                    </ng-template>
                    <ng-template [ngIf]="param.type.includes('combo')">
                      <div class="animated fadeIn col-12">
                        <div class="relative">
                          <input class="form-control cursorPointer" type="text" [(ngModel)]="param.value"
                            (keyup)="change($event, param); handleKeyUp($event, item);"
                            (keydown)="handleKeyDown($event, item)" (click)="openDropdown($event, param, op)"
                            (focus)="openDropdown($event, param, op)" (blur)="handleBlur(param, op, item)"
                            [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                            [ngStyle]="{ 'border': param.highlightRequired ? '1px solid var(--red)' : '1px solid #9b9b9ba6' }" />
                          <fa-icon [icon]="faChevronDown"
                            class="absolute bg-none combo-input-icon padding5" style="pointer-events: none;"                      
                            [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"></fa-icon>
                        </div>
                        <p-overlayPanel #op styleClass="overlay-b">
                          <ng-template pTemplate="content" class="full-width unset-p">
                            <div class="combo-options-container b-radius p-unset overflow-auto full-width"
                              [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                              <div #optionEl *ngFor="let lookupValue of param.filteredLookupValues; let i = index"
                                class="combo-option poppins relative"
                                (mousedown)="updateCombos(false, param, lookupValue, item)"
                                [ngClass]="lookupValue.selected ? 'bg-green textWhite' : settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                                <span class="absolute" style="top: 50%; transform: translate(10px, -50%);">
                                  {{ param.type == 'combolookup' ? lookupValue.lookUpValue.value :
                                  lookupValue.lookUpValue }}
                                </span>
                              </div>
                              <span *ngIf="param.filteredLookupValues && param.filteredLookupValues.length === 0"
                                class="combo-option poppins  flex justify-centre align-centre"
                                [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                                {{app.translations.GBL_lbl_NoResults}}
                              </span>
                            </div>
                          </ng-template>
                        </p-overlayPanel>
                      </div>
                    </ng-template>
                    <ng-template
                      [ngIf]="(param.type == 'text' || param.type == 'textbox') && (param.dataType == 'Int32' || param.dataType == 'Int16')">
                      <input type="number" class="form-control font13" step="1" pattern="[0-9]*"
                        (change)="updateNumericInputs(param, $event)"
                        [value]="selectedLines.length > 0 ? param.preselectedValue : ''"
                        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                        [ngStyle]="{ 'border': param.highlightRequired ? '1px solid var(--red)' : '1px solid #dee2e6' }" />
                    </ng-template>
                    <ng-template
                      [ngIf]="(param.type == 'text' || param.type == 'textbox') && (param.dataType == 'Decimal' || param.dataType == 'Double')">
                      <input type="number" class="form-control font13" (change)="updateNumericInputs(param, $event)"
                        [value]="selectedLines.length > 0 ? param.preselectedValue : ''"
                        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                        [ngStyle]="{ 'border': param.highlightRequired ? '1px solid var(--red)' : 'unset' }" />
                    </ng-template>
                    <ng-template
                      [ngIf]="(param.type == 'date' || param.type == 'datebox' || param.type == 'datetimebox') && (param.dataType == '' || param.dataType == 'DateTime')">
                      <date-picker (dateSelected)="updateDateInputs($event, param)" [param]="param"
                        [settings]="settings" [action]="action"
                        [ngStyle]="{ 'border': param.highlightRequired ? '1px solid var(--red)' : 'unset' }"></date-picker>
                    </ng-template>
                    <ng-template
                      [ngIf]="(param.type == 'time' || param.type == 'timebox') && (param.dataType == '' || param.dataType == 'DateTime' || param.dataType == 'TimeSpan')">
                      <input type="time" class="form-control font13" (change)="updateTextInputs(param, $event)"
                        [value]="selectedLines.length > 0 ? param.preselectedValue : ''"
                        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                        [ngStyle]="{ 'border': param.highlightRequired ? '1px solid var(--red)' : '1px solid #dee2e6' }" />
                    </ng-template>
                    <ng-template
                      [ngIf]="(param.type == 'text' || param.type == 'textbox') && (param.dataType == '' || param.dataType == 'String')">
                      <input type="text" class="font13 form-control" (change)="updateTextInputs(param, $event)"
                        [value]="(selectedLines.length > 0 || pastedDataFromExcel) ? param.preselectedValue : ''"
                        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                        [ngStyle]="{ 'border': param.highlightRequired ? '1px solid var(--red)' : '1px solid #dee2e6' }" />
                    </ng-template>
                    <ng-template [ngIf]="param.type == 'textarea'">
                      <div class="relative">
                        <textarea class="form-control font13 pre-wrap-white-space transition5"
                          (blur)="updateCombos(true, param, item, $event)" [(ngModel)]="param.preselectedValue"
                          (change)="updateTextInputs(param, $event)" rows="2"
                          style="padding: 5px 25px 5px 5px !important;"
                          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                          [ngStyle]="{'border-color': item.sqlError.length > 0 ? 'var(--red)' : '#ced4da'}"
                          [ngStyle]="{ 'border': param.highlightRequired ? '1px solid var(--red)' : '1px solid #dee2e6' }"></textarea>
                        <ng-template [ngIf]="item.sqlError.length > 0">
                          <fa-icon [icon]="faCircleInfo" class="absolute font14 textRed cursorPointer"
                            style="top: 7px; right: 10px;" pTooltip="{{item.sqlError}}" tooltipPosition="top"></fa-icon>
                        </ng-template>
                      </div>
                    </ng-template>
                    <ng-template [ngIf]="param.type == 'password'">
                      <input type="password" autocomplete="new-password"
                        [value]="selectedLines.length > 0 ? param.preselectedValue : ''"
                        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                        (change)="updateTextInputs(param, $event)" class="form-control font13"
                        [ngStyle]="{ 'border': param.highlightRequired ? '1px solid var(--red)' : '1px solid #dee2e6' }" />
                    </ng-template>
                    <ng-template [ngIf]="param.type == 'check' || param.type == 'toggle' || param.type == 'checkbox'">
                      <mat-checkbox (change)="updateCheckboxToggles(param, $event)" [checked]="param.preselectedValue" [indeterminate]="param.preselectedValue == null">
                      </mat-checkbox>
                    </ng-template>
                    <ng-template [ngIf]="param.type == 'image' || param.type == 'imagebox'">
                      <label (click)="fileInput.value = ''" tooltipPosition="top"
                        pTooltip="{{app.translations.GBL_hint_UploadImage}}">
                        <fa-icon [icon]="faArrowUpFromBracket" class="font17 cursorPointer b-radius padding5"
                          [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textGreen'"></fa-icon>
                        <input #fileInput type="file" class="display-none" (change)="updateImage(param, $event)">
                      </label>
                      <ng-template [ngIf]="param.preselectedValue">
                        <img [src]="app.getFormattedImage(param.preselectedValue)"
                          (dblclick)="updateImage(param, undefined)"
                          [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-whtie'"
                          style="width: 30px; margin: 10px;" class="cursorPointer b-radius padding2" />
                      </ng-template>
                    </ng-template>
                  </td>
                </ng-container>
                <ng-template [ngIf]="isSavingGrid">
                  <ng-template [ngIf]="item.saveResult == 'saving'">
                    <td class="padding5" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                      <div class="animated fadeIn">
                        <fa-icon [icon]="faCircleNotch" class="font17 animated rotate"
                          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textGreen'"></fa-icon>
                      </div>
                    </td>
                  </ng-template>
                  <ng-template [ngIf]="item.saveResult == 'success'">
                    <td class="padding5" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                      <div class="animated fadeIn">
                        <fa-icon [icon]="faCheck" class="textGreen font17"></fa-icon>
                        <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                          style="padding-left: 8px;">{{item.message}}</span>
                      </div>
                    </td>
                  </ng-template>
                  <ng-template [ngIf]="item.saveResult == 'error'">
                    <td class="padding5" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                      <div class="animated fadeIn">
                        <fa-icon [icon]="faXmark" class="textRed font17"></fa-icon>
                        <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                          style="padding-left: 8px;">{{item.message}}</span>
                      </div>
                    </td>
                  </ng-template>
                </ng-template>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-template>
    </div>
  </div>
  <div class="row sticky dialog-footer-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 unset-p">
      <div class="flex justify-right padding10 dialog-footer">
        <button class="btn font17" (click)="save()">
          <fa-icon [icon]="faFloppyDisk" class="textGreen"></fa-icon>
          <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
            {{app.translations.GBL_btn_SaveText}}
          </span>
        </button>
      </div>
    </div>
  </div>
</p-dialog>